import React, { Component } from 'react';
import RaisedButton from 'material-ui/RaisedButton';
import TextField from 'material-ui/TextField';
import { FormattedMessage, FormattedHTMLMessage } from 'react-intl';
import { HelpText, RadioText } from './styles';
import config from '../../config/config';
import { parseQuery, checkMobile, checkPad, checkJapanese } from '../../lib';
import { Redirect } from 'react-router-dom'
import { isValidNumberForRegion } from 'libphonenumber-js'

const Text = ({ img, text }) => (
  <span className="flex justify-between items-center pl1">
    <img src={img} alt="radio" className="pr2" />
    <RadioText>{text}</RadioText>
  </span>
);
const requiredText = '入力してください';

const APIurl = `${config.URI}/api/v1/get_fvdomain`

class Form extends Component {
  constructor(props) {
    super(props);

    this.state = {
      companyName: "",
      companySignup: false,
      hasErrors: false,
      userTypeError: false,
      usernameError: null,
      emailError: null,
      passwordError: null,
      rpasswordError: null,
      userType: 'guest',
      url: null,
      fvlite_role: '',
      fvlite_auto_trial: '',
      phone_number: '',
      expiry_days: ''
    };
  }
  getFvdomain = (payload) => {
    return fetch(`${APIurl}`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(payload)
    })
      .then((temp) => temp.json())
      .then(res => res)
      .catch((error) => {
        let warning = checkJapanese() ? 'サーバーとの接続にエラーが発生しました。' : 'There was an error connecting to the server.';
        alert(warning)
      });
  }
  async componentDidMount() {
    const query = parseQuery(this.props.location.search);
    const url = query.url
    const fvlite_role = query.type ? query.type : 'guest'
    if (url) {
      this.setState({ companySignup: true, userType: "admin", url: url, fvlite_role: fvlite_role })
      const payload = { url }
      let res = await this.getFvdomain(payload)
      if (res.status && res.status === 'success') {
        this.setState({ companyName: res.data.name, fvlite_auto_trial: res.data.fvlite_auto_trial })
        this.props.setTrial(res.data.fvlite_auto_trial)
        this.props.setTrialSignup(res.data.fvlite_auto_trial, res.data.expiry_days)
        if (res.data.name) {

        } else {
          let warning = checkJapanese() ? '無効なURLです' : 'Invalid URL';
          alert(warning)
          window.location = "/signup"
        }
      } else if (res.errors) {
        console.error(res.errors);
      }
    }
    else {
      this.props.history.push("/");
    }
  }

  componentWillUnmount() {
    this.props.authErrors(null);
  }

  handleSubmit = e => {
    this.props.authErrors(null);
    const { userType } = this.state;
    e.preventDefault();
    let post = true;
    let passwordsMatch = false;
    const emailFilter = /^(([^<>()\]\\.,;:\s@"]+(\.[^<>()\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    let { username, email, password, rpassword, phone_number, companyName } = this.refs;
    username = username.getValue();
    email = email.getValue();
    password = password.getValue();
    rpassword = this.state.fvlite_auto_trial ? '' : rpassword.getValue();
    phone_number = this.state.fvlite_auto_trial ? phone_number.getValue() : ''
    companyName = this.state.fvlite_auto_trial ? companyName.getValue() : ''


    if (!username) {
      this.setState({
        usernameError: this.state.fvlite_auto_trial ? requiredText : <FormattedMessage id="login.requiredField" />,
        hasErrors: true
      });
      post = false;
    } else {
      this.setState({ usernameError: null });
    }
    if (this.state.fvlite_auto_trial && !companyName) {
      this.setState({
        companyNameError: requiredText,
        hasErrors: true
      });
      post = false;
    } else {
      this.setState({ companyNameError: null });
    }

    if (this.state.fvlite_auto_trial && !phone_number) {
      this.setState({
        phone_numberError: requiredText,
        hasErrors: true
      });
      post = false;
    }
    else if (this.state.fvlite_auto_trial && !isValidNumberForRegion(phone_number, 'JP')) {
      this.setState({
        phone_numberError: (
          'ハイフンなしで有効な電話番号を入力して下さい'
        ),
        hasErrors: true
      });
      post = false;
    }
    else {
      this.setState({ phone_numberError: null });
    }

    if (!email) {
      this.setState({
        emailError: this.state.fvlite_auto_trial ? requiredText : <FormattedMessage id="login.requiredField" />,
        hasErrors: true
      });
      post = false;
    } else if (!emailFilter.test(email)) {
      this.setState({
        emailError: this.state.fvlite_auto_trial ? 'Emailの形式が正しくありません。' : <FormattedMessage id="signUp.emailError" />,
        hasErrors: true
      });
      post = false;
    } else {
      this.setState({ emailError: null });
    }

    if (!password) {
      this.setState({
        passwordError: this.state.fvlite_auto_trial ? requiredText : <FormattedMessage id="login.requiredField" />,
        hasErrors: true
      });
      post = false;
    } else if (password.length < 6) {
      this.setState({
        passwordError: this.state.fvlite_auto_trial ? '6文字以上で設定してください。' : <FormattedMessage id="signUp.passwordError.short" />,
        hasErrors: true
      });
      post = false;
    } else if (
      password.search(/^[a-z0-9]+$/i) === -1
    ) {
      this.setState({
        passwordError: (
          this.state.fvlite_auto_trial ?
            '数字とアルファベットの両方を1文字以上使用してください。' :
            <FormattedMessage id="signUp.passwordError.alphaNumeric" />
        ),
        hasErrors: true
      });
      post = false;
    } else if (!this.state.fvlite_auto_trial && password !== rpassword) {
      this.setState({
        passwordError: <FormattedMessage id="signUp.passwordError.dontMatch" />,
        rpasswordError: (
          <FormattedMessage id="signUp.passwordError.dontMatch" />
        ),
        hasErrors: true
      });
      post = false;
    } else {
      this.setState({ passwordError: null });
      passwordsMatch = true;
    }

    if (!this.state.fvlite_auto_trial && !rpassword) {
      this.setState({
        rpasswordError: <FormattedMessage id="login.requiredField" />,
        hasErrors: true
      });
      post = false;
    }

    if (passwordsMatch) {
      this.setState({ rpasswordError: null });
    }

    if (post) {
      this.setState({ hasErrors: false });
      this.props.signupUser(email, password, username, userType, this.state.url, this.state.fvlite_role, phone_number, companyName);
    }
  };

  handleChange = (e, value) => {
    this.setState({ userTypeError: false, userType: value });
  };

  render() {
    if (this.props.loginStatus) {
      if (checkMobile() || checkPad()) {
        let warning = checkJapanese() ? 'PC Google Chromeからログインして、使用してください。モバイルからは使用できません。' : 'Please log in from PC Google Chrome and use it. Not available on mobile.';
        alert(warning)
        return (
          window.location.href = 'https://www.freshvoice.net/lite/'
        )
      }
      else {
        return (
          <Redirect
            to={'/admin'}
          />
        )
      }
    }
    const uncheckedIconColor = this.state.userTypeError ? '#f44336' : '#6B7C93';
    let style = {};
    let labelStyle = {};
    let inputStyle = {};
    let content = '';
    let btnStyle = {};
    let shrinkStyle = {}
    if (this.state.fvlite_auto_trial) {
      style = {
        background: '#e6e6e6',
        padding: '1px 50px 1px 61px',
        marginTop: '20px',
        fontSize: '12px'
      }
      content = this.state.fvlite_auto_trial ? '下記ボタンをクリックすると使い方を記載したメールが届きます。' : <FormattedMessage id="signUp.startTrial" />
      labelStyle = {
        fontSize: '13px',
        color: '#898989'
      }
      inputStyle = {
        fontSize: '15px'
      }
      btnStyle = {
        minWidth: '70%',
        marginLeft: '15%',
      }
      shrinkStyle = {
        color: '#50a3a7'
      }
    }
    return (
      <form autoComplete="off" onSubmit={this.handleSubmit}>
        {this.props.errors && this.props.errors.length >= 1 ? (
          <div className="tc red">
            {this.props.errors.map((err, index) => (
              <p key={index}>
                {err}
              </p>
            ))}
          </div>
        ) : (
            ''
          )}
        <input style={{ display: 'none' }} type="email" name="email" />
        <input style={{ display: 'none' }} type="password" name="password" />
        <div className="mb2">
        </div>
        <div>
          <div className="mb2">
            {!this.state.fvlite_auto_trial && <div>
              {this.state.companySignup && <TextField
                floatingLabelStyle={{
                  marginTop: -10,
                }}
                ref="companyName"
                style={{ height: 65 }}
                floatingLabelText={this.state.companyName}
                fullWidth
                disabled
              />}
              {this.state.fvlite_role && <TextField
                floatingLabelStyle={{
                  marginTop: -10
                }, labelStyle}
                floatingLabelShrinkStyle={shrinkStyle}
                ref="AccountType"
                style={{ height: 65 }}
                floatingLabelText={this.state.fvlite_role}
                fullWidth
                disabled
              />} </div>}
            {this.state.fvlite_auto_trial && <div>
              <TextField
                floatingLabelStyle={{
                  marginTop: -10
                }, labelStyle}
                floatingLabelShrinkStyle={shrinkStyle}
                ref="companyName"
                name="companyName"
                style={{ height: 65 }, inputStyle}
                floatingLabelText={this.state.fvlite_auto_trial ? '会社名' : <FormattedMessage id="signUp.companyLabel" />}
                fullWidth
                errorText={this.state.companyNameError}
              />
              <TextField
                floatingLabelStyle={{
                  marginTop: -10
                }, labelStyle}
                floatingLabelShrinkStyle={shrinkStyle}
                ref="phone_number"
                style={{ height: 65 }}
                floatingLabelText={this.state.fvlite_auto_trial ? '電話番号' : <FormattedMessage id="signUp.phoneLabel" />}
                fullWidth
                errorText={this.state.phone_numberError}
              />  </div>}
            <TextField
              floatingLabelStyle={{
                marginTop: -10
              }, labelStyle}
              floatingLabelShrinkStyle={shrinkStyle}
              style={{ height: 65 }}
              hintText={this.state.fvlite_auto_trial ? '山田' : <FormattedMessage id="signUp.userplaceholder" />}
              floatingLabelText={this.state.fvlite_auto_trial ? 'ユーザ名' : <FormattedMessage id="signUp.usernameLabel" />}
              fullWidth
              ref="username"
              errorText={this.state.usernameError}
            />
            <TextField
              floatingLabelStyle={{
                marginTop: -10,
              }, labelStyle}
              floatingLabelShrinkStyle={shrinkStyle}
              style={{ height: 65 }}
              hintText="yamada@yamada.com"
              floatingLabelShrinkStyle={shrinkStyle}
              floatingLabelText={this.state.fvlite_auto_trial ? 'Eメールアドレス' : <FormattedMessage id="login.emailLable" />}
              fullWidth
              type="email"
              name="email"
              ref="email"
              errorText={this.state.emailError}
            />
            <TextField
              floatingLabelStyle={{
                marginTop: -10
              }, labelStyle}
              floatingLabelShrinkStyle={shrinkStyle}
              style={{ height: 65 }}
              hintText="********"
              floatingLabelText={this.state.fvlite_auto_trial ? 'パスワード(6文字以上)' : <FormattedMessage id="login.passwordLable" />}
              type="password"
              fullWidth
              name="password"
              autoComplete="off"
              ref="password"
              errorText={this.state.passwordError}
            />
            {!this.state.fvlite_auto_trial &&
              <TextField
                floatingLabelStyle={{
                  marginTop: -10
                }, labelStyle}
                floatingLabelShrinkStyle={shrinkStyle}
                style={{ height: 65 }}
                hintText="********"
                floatingLabelText={
                  <FormattedMessage id="signUp.confirmPasswordLabel" />
                }
                type="password"
                fullWidth
                ref="rpassword"
                errorText={this.state.rpasswordError}
              />}
          </div>
          <div style={{ textAlign: 'center', padding: '10px', fontSize: '13px' }}>{content}</div>
          <RaisedButton
            backgroundColor={this.state.fvlite_auto_trial ? "#0e400e" : "#FCCE42"}
            label={this.state.fvlite_auto_trial ? '無料トライアルを開始する' : <FormattedMessage id="signUp.createAccount" />}
            type="submit"
            fullWidth
            labelStyle={{ fontWeight: 'normal' }}
            labelColor={this.state.fvlite_auto_trial ? "#ffffff" : "#8B7124"}
            style={btnStyle}
          />
          <div className="tc" style={style}>
            <HelpText style={{ fontSize: '12px' }}>
              {this.state.fvlite_auto_trial ? '本サービスのアカウントを作成することにより,次の規約に同意したものとみなされます。' : <FormattedMessage id="signUp.agree" />}
            </HelpText>
            <HelpText>
              {this.state.fvlite_auto_trial ? <a style={{ color: '#000' }} class="link black" href="https://workshop-live.com/term-jp.html">利用規約</a> : <FormattedHTMLMessage id="footerMenu.terms" />}
              {this.state.fvlite_auto_trial ? 'と' : <FormattedMessage id="signUp.and" />}
              {this.state.fvlite_auto_trial ? <a style={{ color: '#000' }} class="link black" href="https://workshop-live.com/privacy-jp.html">プライバシーポリシー</a> : <FormattedHTMLMessage id="footerMenu.policy" />}
            </HelpText>
          </div>
        </div>
      </form>
    );
  }
}

export default Form;


// WEBPACK FOOTER //
// src/components/SignUpForm/SignUpForm.js